






import { Vue, Component, Prop } from "vue-property-decorator";
import { Activity } from "@/graphql/query/activity/feed";
import { AppAccountLink } from "./helper";

@Component({ components: { AppAccountLink } })
export default class CreateAppAccountLog extends Vue {
  @Prop({ type: Object, required: true }) activity!: Activity;
}
